var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeftLong(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 15,
    viewBox: "0 0 41 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.292892 8.07136C-0.0976295 7.68084 -0.0976295 7.04768 0.292892 6.65715L6.65685 0.29319C7.04738 -0.0973344 7.68054 -0.0973344 8.07107 0.29319C8.46159 0.683714 8.46159 1.31688 8.07107 1.7074L2.41422 7.36426L8.07107 13.0211C8.46159 13.4116 8.46159 14.0448 8.07107 14.4353C7.68054 14.8259 7.04738 14.8259 6.65685 14.4353L0.292892 8.07136ZM41 7.36426V8.36426L1 8.36426V7.36426V6.36426L41 6.36426V7.36426Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftLong);
export default __webpack_public_path__ + "static/media/Arrow-left-long.c57735c62769841e72e85ffd59e716ed.svg";
export { ForwardRef as ReactComponent };